import { useState } from "react";
import Loading from "components/Loading";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getVideoDetail } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import VideoInfo from "./videoInfo";
import VideoInfluencer from "./influencer";
import ModalPreview from "../modalPreview";
import VideoDashboard from "./dashboard";

const VideoDetail = ({ getVideoDetail }) => {
    const { id } = useParams();
    const [openPreview, setOpenPreview] = useState(false);
    const { data: video, loading } = useCallApi(getVideoDetail, id);

    if (!video && loading) return <Loading isLoading={true} />;
    if (!video) return;

    return (
        <div style={{ maxWidth: "1580px", margin: "auto" }}>
            <div className="card mb-5 mb-xl-10">
                <Loading isLoading={loading} />
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="spy-video-preview" onClick={() => setOpenPreview(true)}>
                                <img className="w-100" alt="video_preview" src={video.cover_url?.[0]} />
                                <div className="position-absolute top-0 start-0 w-100 h-100 justify-content-center align-items-center backdrop">
                                    <i className="ki-duotone ki-to-right fs-3x"></i>
                                </div>
                            </div>
                        </div>

                        <VideoInfo video={video} />
                        <VideoInfluencer video={video} />
                    </div>
                </div>
            </div>
            <VideoDashboard video={video} />
            <ModalPreview isOpen={openPreview} onClose={() => setOpenPreview(false)} previewLink={video.share_url} />
        </div>
    );
};

export default connect(null, { getVideoDetail })(VideoDetail);
